import { HugeiconsIconProps } from "@hugeicons/react";
import {
  DashboardIcon,
  LeadIcon,
  PageIcon,
  PipelineIcon,
  SendIcon,
  TaskIcon,
} from "@/components/ui/icons";
import { WorkflowSquare02Icon } from "@hugeicons/core-free-icons";

export interface NavbarNavLink {
  href: string;
  label: string;
  active?: boolean;
  icon: HugeiconsIconProps["icon"];
  /** Optional unread count rendered as a red bubble over the icon. */
  badge?: number;
}

// Single source of truth for the top-level nav — the xl+ navbar and the
// mobile/tablet menu drawer both render this list, so an entry added here
// shows up on every viewport. Order matters; matches the active-link logic.
// Inbox lives inside Outreach — no standalone nav entry.
export const defaultNavigationLinks: NavbarNavLink[] = [
  { href: "/home", label: "Dashboard", icon: DashboardIcon },
  { href: "/leads", label: "Leads", icon: LeadIcon },
  { href: "/sequences", label: "Sequences", icon: WorkflowSquare02Icon },
  { href: "/outreach", label: "Outreach", icon: SendIcon },
  { href: "/tasks", label: "Tasks", icon: TaskIcon },
  { href: "/pipelines", label: "Pipeline", icon: PipelineIcon },
  { href: "/pages", label: "Pages", icon: PageIcon },
];
